import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';

import questionIconHelpLink from '../../images/QuestionIcon.svg';
import logoutIcon from '../../images/logout.svg';
import logout from '../helpers/logout';

const getHelpLink = (formType, ledgerRegion) => {
  const helpLinks = {
    bas: 'http://help.myob.com/wiki/display/ar/Get+ready+to+lodge+activity+statements+online',
    egst: 'http://help.myob.com/wiki/pages/viewpage.action?pageId=5669072',
    defaultLink: `https://www.myob.com/${ledgerRegion || 'au'}/support/accountright`
  };
  return helpLinks[formType] || helpLinks['defaultLink'];
};
function tokenExpiryListenerFromIFrame() {
  const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
  const eventer = window[eventMethod];
  const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
  const boundLogoutClick = this.onLogoutClick;
  eventer(messageEvent, event => {
    if (event.data === 'TokenExpired') {
      boundLogoutClick();
    }
  }, false);
}

export const Header = React.createClass({
  propTypes: {
    backToListPath: React.PropTypes.string,
    savedUriState: React.PropTypes.object
  },

  onLogoutClick() {
    logout(this.props.savedUriState);
  },

  componentDidMount(){
    tokenExpiryListenerFromIFrame.call(this);
  },

  render() {
    const formType = get('savedUriState.formType', this.props);
    const ledgerRegion = get('savedUriState.ledgerRegion', this.props);
    const helpLink = getHelpLink(formType, ledgerRegion);
    return (
      <div id="headerContainer" className="arlshell-header-container">
        <div id="header">
          <header className="navbar navbar-inverse" id="taxonline-header-rebranded"
                  role="navigation">
            <div className="container">
              <div className="navbar-header">
                {
                  this.props.backToListPath
                    ? <Link to={`${this.props.backToListPath}`} className="navbar-brand logo">MYOB</Link>
                    : <a href={window.location.href} className="navbar-brand logo" disabled>MYOB</a>
                }
              </div>
              <div className="navbar-subtitle navbar-right logout">
                <a href="#" onClick={this.onLogoutClick}>Log out <img
                  src={logoutIcon}/></a>
              </div>
              <div className="navbar-subtitle helplink">
                <a href={helpLink} target="_blank">
                  <img src={questionIconHelpLink}/>
                </a>
              </div>
            </div>
          </header>
        </div>
      </div>
    )
  }
});

export default connect(
  state => ({
    backToListPath: state.navigation.backToListPath,
    savedUriState: state.auth.savedUriState
  })
)(Header)



// WEBPACK FOOTER //
// ./src/app/components/Header.js